import { createContext } from 'react';
import { type EnhancedClientSummaryResponse } from '@/types/Auth';

export interface AuthContext {
  client: EnhancedClientSummaryResponse | undefined;
  isAuthenticated: boolean;
  maskLogin: (login: number | null) => string;
  onboardingModalOpen: boolean;
  setClient: React.Dispatch<React.SetStateAction<EnhancedClientSummaryResponse | undefined>>;
  setOnboardingModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setToken: React.Dispatch<React.SetStateAction<string | undefined>>;
  token: string | undefined;
}

export const AuthContext = createContext<AuthContext | undefined>(undefined);
